//here i have written common grids for config module

import React from "react";
import { useState, useEffect } from "react";

import { Popconfirm, Space, Table, Menu, Dropdown, Button, Skeleton, Modal } from "antd";
import { DownOutlined } from '@ant-design/icons';

// import errorNew from "../../../assets/error/error.png";
import {
  QuestionCircleOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ContextMenu } from "../components/Elements/ContextMenu";
import { useStoreUpdaterWithAPI } from "../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import CustomHeader from "../components/Elements/CustomAgHeader";



//configuration start
export const GroupGrid = ({
  handleUpdatePopup,
  handleDeletePopup,
  handleDeleteSubmit,
  flowGroupList,
  groupModuleList,
  reportStatusList,
}) => {
  console.log(groupModuleList);

  const enhancedFlowGroupList = flowGroupList.map((item) => {
    const groupModule = groupModuleList.find(
      (module) => module.moduleID === item.groupModule
    );
    const reportStatus = reportStatusList.find(
      (status) => status.reportStatusID === item.reportStatus
    );

    return {
      ...item,
      groupModuleName: groupModule ? groupModule.moduleName : "Unknown Module",
      reportStatusName: reportStatus
        ? reportStatus.reportStatusName === "Yes"
          ? "Allow"
          : "Not Allow"
        : "Unknown Status",
    };
  });

  const flowGroupListWithAction = enhancedFlowGroupList.map((item) => ({
    ...item,
    actions: {
      update: handleUpdatePopup,
      delete: handleDeletePopup,
      confirmDelete: handleDeleteSubmit,
    },
  }));

  const columnDefs = [
    {
      headerName: "Group Name",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Group Module",
      field: "groupModuleName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      headerComponent: CustomHeader, 
      headerComponentParams: {
        displayName: 'Group Module', 
      },
      flex: 2,
    },
    {
      headerName: "Report Status",
      field: "reportStatusName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button
              onClick={() => {
                params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button>

            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(params.data.groupID); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={flowGroupListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};

// Group Metr Grid
export const GroupMeterGrid = ({
  handleUpdatePopup,
  flowGroupMeterList = [],
  handleDeletePopup,
  handleDeleteSubmit,
  uspList = [],
}) => {
  console.log(flowGroupMeterList);
  const flowGroupMeterListName = flowGroupMeterList.map((item) => {
    const uspType = uspList.find(
      (module) => module.sitE_ID === item.converterID
    );
    return {
      ...item,
      uspList: uspType ? uspType.sitename : "Unknown Module",
    };
  });

  const flowGroupMeterListWithAction = flowGroupMeterListName.map((item) => ({
    ...item,
    actions: {
      update: handleUpdatePopup,
      delete: handleDeletePopup,
      confirmDelete: handleDeleteSubmit,
    },
  }));

  const columnDefs = [
    {
      headerName: "Group Name",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Sub Group Name",
      field: "subGroupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Converter Name",
      field: "uspList",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Meter Name",
      field: "meterName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button onClick={() => params.data.actions.update(params.data)}>
              <EditOutlined />
            </Button>
            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(
                  params.data.groupMeterDetailID
                );
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={flowGroupMeterListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};

//sub group
export const SubGroupGrid = ({
  handleUpdatePopup,
  flowSubGroupList,
  handleDeletePopup,
  handleDeleteSubmit,
  calculationTypeList,
  reportStatusList,
}) => {
  console.log(flowSubGroupList);
  console.log(reportStatusList);
  console.log(calculationTypeList);

  const flowSubGroupListName = flowSubGroupList.map((item) => {
    const calculationType = calculationTypeList.find(
      (module) => module.calculationTypeID === item.calculationTypeID
    );
    const reportStatus = reportStatusList.find(
      (status) => status.reportStatusID === item.reportStatus
    );
    console.log(calculationType);
    console.log(reportStatus);
    return {
      ...item,
      calculationTypeID: calculationType
        ? calculationType.calculationTypeName
        : "Unknown Module",
      reportStatus: reportStatus
        ? reportStatus.reportStatusName === "Yes"
          ? "Allow"
          : "Not Allow"
        : "Unknown Status",
    };
  });

  // console.log(flowSubGroupListName)
  const flowGroupListWithAction = flowSubGroupListName.map((item) => ({
    ...item,
    actions: {
      update: handleUpdatePopup,
      delete: handleDeletePopup,
      confirmDelete: handleDeleteSubmit,
    },
  }));

  const columnDefs = [
    {
      headerName: "Group Name",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 1,
    },
    {
      headerName: "Sub Group Name",
      field: "subGroupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 1,
    },
    {
      headerName: "Sub Group Type",
      field: "calculationTypeID",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 1,
    },
    {
      headerName: "Report Status",
      field: "reportStatus",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 1,
    },

    {
      headerName: "Action",
      headerClass: "grid-table-header",
      // width:50,

      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button
              onClick={() => {
                // console.log("Row Data:", params.data);
                params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button>
            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                // console.log("Row Data:", params.data);
                params.data.actions.confirmDelete(params.data.subGroupID); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    // floatingFilter: true,
  };

  const mode = useSelector((state) => state.darkMode);

const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={flowGroupListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};

//configuration end

//Electrical start

//plant module

export const MainGrid = ({
  plantData,
  handleUpdateModel,
  handleDeleteModel,
  handleDeleteSubmit,
}) => {
  console.log(plantData);
  const plantDataWithAction = plantData.map((item) => ({
    ...item,
    actions: {
      update: handleUpdateModel,
      delete: handleDeleteModel,
      confirmDelete: handleDeleteSubmit,
    },
  }));

  // console.log(plantData)
  const columnDefs = [
    {
      headerName: "Plant Name",
      field: "masterPlantName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Group Name",
      field: "detailGroupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Graph Name",
      field: "detailControlName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button
              onClick={() => {
                params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button>

            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                console.log(params.data.detailPlantDetailID);
                params.data.actions.confirmDelete(
                  params.data.detailPlantDetailID
                ); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  return (
    <>
      <div className="App">
        <div
          className="ag-theme-alpine"
          style={{ height: "400px", width: "100%" }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowData={plantDataWithAction}
            defaultColDef={defaultColDef}
            pagination={true}
          />
        </div>
      </div>
    </>
  );
};

//plant module second grid

export const SecondGrid = ({
  plantNameList,
  handlePlantDeleteModel,
  handleDeletePlantName,
}) => {
  console.log(plantNameList);
  const plantDataWithAction = plantNameList.map((item) => ({
    ...item,
    actions: {
      delete: handlePlantDeleteModel,
      confirmDelete: handleDeletePlantName,
    },
  }));

  // console.log(plantData)
  const columnDefs = [
    {
      headerName: "PlantId",
      field: "plantid",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Plant Name",
      field: "plantName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },

    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(params.data.plantid); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  return (
    <>
      <div className="App">
        <div
          className="ag-theme-alpine"
          style={{ height: "400px", width: "100%" }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowData={plantDataWithAction}
            defaultColDef={defaultColDef}
            pagination={true}
          />
        </div>
      </div>
    </>
  );
};

// parameter view grid

export const ParameterViewGrid = (
  {
    // converterList
  }
) => {
  const columnDefs = [
    {
      headerName: "Meter Name",
      // field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
      
    },
    {
      headerName: "Status",
      // field: "groupModuleName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "VR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "VY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "VB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "F",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "VRY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: "#e2e2e2" },
      width: 150,
    },
    {
      headerName: "VYB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: "#e2e2e2" },
      width: 150,
    },
    {
      headerName: "VBR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "VLLAvg",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "IR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "IY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "IB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "IAVG",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "Vunb",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "lunb",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWT",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVAT",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVART",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "PFT",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "PFR",
      field: "reportStatusName", // change to the new field name
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "PFY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "PFB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },

    {
      headerName: "KWB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVAR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVAY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVAB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVARR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVARY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVARB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWD",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVAD",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWHTotal",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWHImport ",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWHExpot",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "kVAH",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "kVArhTotal",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "kVArhinductive",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVARHCAPACITIVE",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    filter: true,
    
  };

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          scroll={{ x: "max-content" }}
          columnDefs={columnDefs}
          // rowData={converterList}
          defaultColDef={defaultColDef}
          pagination={true}
          alwaysShowHorizontalScroll={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-parameter ' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};


//Converter config grid in configuration 
export const ConverterConfigGrid = ({
 data,
  handleDeleteSubmit,
  refetch,
  setRefetch
  
}) => {
  console.log(data)
  

  const columnDefs = [
    {
      headerName: "S. No.",
      field: "serialNo", 
      headerClass: "grid-table-header",
      cellRenderer: (params) => params.node.rowIndex + 1,
      cellStyle: { borderRightColor: " #e2e2e2" },
      
    },
    
    {
      headerName: "Converter Name",
      field: "siteName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
     
    },
    {
      headerName: "Converter ID",
      field: "siteID",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
    
    },
    {
      headerName: "IP Address",
      field: "siteIP", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
     
    },
    {
      headerName: "Port",
      field: "port", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
     
    },
    {
      headerName: "No. of Ports",
      field: "noofPorts",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
     
    },
    {
      headerName: "Eletrical",
      field: "isElectrical",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      cellDataType: "text", // Ensures values are displayed as-is
      valueFormatter: null, // Prevents any formatting
     
    },
    {
      headerName: "Temperature",
      field: "isTemperature",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      cellDataType: "text", // Ensures values are displayed as-is
      valueFormatter: null, // Prevents any formatting
    },
    {
      headerName: "Air",
      field: "isAir",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      cellDataType: "text", // Ensures values are displayed as-is
      valueFormatter: null, // Prevents any formatting
    },
    {
      headerName: "Water",
      field: "isWater",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      cellDataType: "text", // Ensures values are displayed as-is
      valueFormatter: null, // Prevents any formatting
    },
    {
      headerName: "Steam",
      field: "isSteam",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      cellDataType: "text", // Ensures values are displayed as-is
      valueFormatter: null, // Prevents any formatting
    },
    // {
    //   headerName: "Delete",
    //   headerClass: "grid-table-header",
    //   width: 100,
    //   cellRenderer: (params) => {
    //     return (
    //       <div className="space-x-2">
    //         {/* <Button
    //           onClick={() => {
    //             params.data.actions.update(params.data);
    //           }}
    //         >
    //           <EditOutlined />
    //         </Button> */}

    //         <Popconfirm
    //           title="Are you sure to delete this Converter"
    //           // description="Are you sure to delete this Converter Configuration?"
    //           icon={<QuestionCircleOutlined style={{ color: "red" }} />}
    //           onConfirm={() => handleDeleteSubmit(params.data.siteID)}
    //           trigger="click"
    //         >
    //           <Button className="text-red-500">
    //             <DeleteOutlined />
    //           </Button>
    //         </Popconfirm>
    //       </div>
    //     );
    //   },
    // },
  ];

  const defaultColDef = {
    sortable: true,
    // editable: true,
    width: 170,
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
 

  return (
    <div className="App">
      <div
        className="ag-theme-alpine" 
        style={{ height: "400px", width: "100%" ,overflowX:'auto'}}
      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={data}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
          domLayout="autoHeight"
        />
      </div>
    </div>
  );
};


export const MeterConfigGrid = ({
  handleDeleteSubmit,
  data,
}) => {
  console.log(data);

  // Meter Config in configuration
  const columnDefs = [
    {
      headerName: "S.NO",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: "#e2e2e2" },
      cellRenderer: (params) => {
        const serialNumber = params.rowIndex + 1;
        return serialNumber;
      },
      width: 90,
    },
    {
      headerName: "Converter ID",
      field: "sitE_ID",
      headerClass: "grid-table-header",
      width: 150,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "ConverterName",
      field: "sitename",
      headerClass: "grid-table-header",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Device ID",
      field: "meteR_METERID",
      headerClass: "grid-table-header",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Device Name",
      field: "metername",
      headerClass: "grid-table-header",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Device Model",
      field: "metermodel",
      headerClass: "grid-table-header",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Module",
      field: "module",
      headerClass: "grid-table-header",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Device Supplier",
      field: "meterSupplier",
      headerClass: "grid-table-header",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "IP Address",
      field: "ipAddress",
      headerClass: "grid-table-header",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Port No.",
      field: "portNo",
      headerClass: "grid-table-header",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 180,
      cellRenderer: (params) => {
        console.log("Params :", params);
        const actions = params.data?.actions;
        console.log("Action :", actions);
        console.log(params.data);
        return (
          <div className="space-x-2">
            <Button
              onClick={() => {
                if (actions && actions.update) {
                  console.log(params.data)
                  actions.update(params.data);
                }
              }}
            >
              <EditOutlined />
            </Button>
            {/* <Button
              className="text-red-500"
              onClick={() =>
                handleDeleteSubmit(
                  params.data.meterid,
                  params.data.departmenT_ID,
                  params.data.sitE_ID
                )
              }
            >
              <DeleteOutlined />
            </Button> */}

            <Popconfirm
              title="Are you sure to delete this Converter"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() =>   handleDeleteSubmit(
                params.data.meterid,
                params.data.departmenT_ID,
                params.data.sitE_ID
              )}
              trigger="click"
            >
              <Button
              className="text-red-500">
              <DeleteOutlined />
            </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    // width:300,
    filter: true,
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div
      className="ag-theme-alpine"
      style={{ height: "400px", width: "100%",overflowX:"auto" }}
    >
      <AgGridReact
        columnDefs={columnDefs}
        rowData={data}
        // defaultColDef={defaultColDef}
        pagination={true}
        className={`${
          isdarkMode
            ? "custom-table-dark-group custom-table-dark-parameter"
            : "whitemode"
        }`}
        domLayout="normal"
      />
    </div>
  );
};


export const UserConfigGrid = ({

  handleDeletePopup,
  handleDeleteSubmit,
 
}) => {
  



  const columnDefs = [
   
    {
      headerName: "UserName",
      field: "groupModuleName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "FirstName",
      field: "reportStatusName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Designation",
      field: "groupModuleName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Admin",
      field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "EmailID",
      field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    // {
    //   headerName: "Action",
    //   headerClass: "grid-table-header",
    //   width: 50,
    //   cellRenderer: (params) => {
    //     return (
    //       <div className="space-x-2">
    //         <Button
    //           onClick={() => {
    //             params.data.actions.update(params.data);
    //           }}
    //         >
    //           <EditOutlined />
    //         </Button>

    //         <Popconfirm
    //           title="Delete  Converter Configuration"
    //           description="Are you sure to delete this Converter Configuration?"
    //           icon={<QuestionCircleOutlined style={{ color: "red" }} />}
    //           onConfirm={() => {
    //             params.data.actions.confirmDelete(params.data.groupID); // to submit. handleDeleteSubmit
    //           }}
    //           trigger="click"
    //         >
    //           <Button className="text-red-500">
    //             <DeleteOutlined />
    //           </Button>
    //         </Popconfirm>
    //       </div>
    //     );
    //   },
    // },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact 
          columnDefs={columnDefs}
          // rowData={flowGroupListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};



//steam sub group grid
export const SteamSubGroupGrid = ({

  handleDeletePopup,
  handleDeleteSubmit,
 
}) => {
  


 

  const columnDefs = [
    {
      headerName: "Group",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Sub Group",
      field: "groupModuleName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "SubGroup Type",
      field: "reportStatusName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Report Status",
      field: "groupModuleName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
   
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button
              onClick={() => {
                params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button>

            <Popconfirm
              title="Delete  Converter Configuration"
              description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(params.data.groupID); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          // rowData={flowGroupListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};

export const SteamGroupMeterGrid = ({
  
}) => {
 

  const columnDefs = [
    {
      headerName: "Group Name",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Sub Group Name",
      field: "subGroupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Converter Name",
      field: "uspList",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Meter Name",
      field: "meterName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button onClick={() => params.data.actions.update(params.data)}>
              <EditOutlined />
            </Button>
            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(
                  params.data.groupMeterDetailID
                );
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          // rowData={flowGroupMeterListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};



export const WaterSubGroupGrid = ({

  handleDeletePopup,
  handleDeleteSubmit,
 
}) => {
  


 

  const columnDefs = [
    {
      headerName: "Group",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Sub Group",
      field: "groupModuleName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "SubGroup Type",
      field: "reportStatusName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Report Status",
      field: "groupModuleName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
   
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button
              onClick={() => {
                params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button>

            <Popconfirm
              title="Delete  Converter Configuration"
              description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(params.data.groupID); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          // rowData={flowGroupListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};

export const WaterGroupMeterGrid = ({
  
}) => {
 

  const columnDefs = [
    {
      headerName: "Group Name",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Sub Group Name",
      field: "subGroupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Converter Name",
      field: "uspList",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Meter Name",
      field: "meterName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button onClick={() => params.data.actions.update(params.data)}>
              <EditOutlined />
            </Button>
            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(
                  params.data.groupMeterDetailID
                );
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          // rowData={flowGroupMeterListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};